import { z } from 'zod';

import { AbstractMeasurement } from './AbstractMeasurement';

const units = ['ohm/m', 'ohm/km', 'ohm/ft', 'mohm/m', 'mohm/km', 'mohm/ft'] as const;
const unit = z.enum(units).default('ohm/m');

const validator = AbstractMeasurement.value
    .extend({
        unit,
    })
    .default({});

export const ResistancePerUnitLength = {
    validator,
    units,
    unit,
};

export type ResistancePerUnitLength = z.infer<typeof validator>;
